export { default as SingleSelector } from './SingleSelector';



// WEBPACK FOOTER //
// ./src/components/FormControls/SingleSelector/index.ts